
import { useState, useEffect, useMemo } from 'react';
import { ContentItem } from "@/components/dashboard/content-card/types";
import { useSearch } from "@/contexts/search/SearchContext";

export const useSearchFilter = (items: ContentItem[]) => {
  const { searchQuery } = useSearch();
  
  const filteredItems = useMemo(() => {
    if (!searchQuery || !searchQuery.trim()) {
      return items;
    }
    
    const searchTermLower = searchQuery.toLowerCase();
    
    return items.filter(item => {
      const titleMatch = item.title?.toLowerCase().includes(searchTermLower);
      const descriptionMatch = item.description?.toLowerCase().includes(searchTermLower);
      
      return titleMatch || descriptionMatch;
    });
  }, [items, searchQuery]);

  return filteredItems;
};
